import React, { useRef, useState } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton, IonCol, IonGrid, IonRow} from '@ionic/react';

import '../css/hotelCss.css';

export function UpdateCheckOutDateModal(props) {

    let [newEndDate, setNewEndDate] = useState(null)


    let [disableSubmitButton, setDisableSubmitButton] = useState(false);


    function submitHandler() {

        setDisableSubmitButton(true);

        //alert('In SubmitHandler');
        //alert(newEndDate);
        
        props.onSubmitNewDate(['OUT', new Date( new Date(newEndDate).getTime() + Math.abs(new Date(newEndDate).getTimezoneOffset()*60000))]);

        //props.closeModal();

    }

    function closeModalHandler() {

        props.closeModal();
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
                <IonGrid> 
                    <IonRow>
                        <IonCol>
                            <label for='newDate'>Select New Check-Out Date: </label>
                        </IonCol>
                        <IonCol className='inputDate'>
                            <IonInput type='date' id='newDate' placeholder='Enter Date' onIonChange={(e) => setNewEndDate(e.target.value)}></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonButton disabled={disableSubmitButton}  onClick={submitHandler}> Submit </IonButton> 
                        </IonCol>
                    </IonRow>
                </IonGrid>                        
            <IonButton className='button_closeModal_center' onClick={closeModalHandler}>Cancel </IonButton>
        </IonModal>) : null}
    </React.Fragment>
    )
}
